import React, { useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import { Building2, Mail, Lock, ArrowRight } from 'lucide-react';

export default function EmployerLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await api.post('/employer/login', {
                email,
                password
            });

            if (response.data.status === 'success') {
                localStorage.setItem('employer_token', response.data.token);
                localStorage.setItem('employer', JSON.stringify(response.data.employer));
                navigate('/employer/profile');
            }
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || 'Invalid credentials or account inactive.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 dark:bg-gray-900 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-xl border border-gray-100 dark:border-gray-700 space-y-6">
                <div className="text-center space-y-2">
                    <div className="w-14 h-14 bg-yellow-400 text-black font-extrabold rounded-2xl flex items-center justify-center mx-auto text-2xl shadow-md">
                        <Building2 size={28} />
                    </div>
                    <h2 className="text-2xl font-extrabold text-gray-900 dark:text-white">Employer Portal</h2>
                    <p className="text-xs text-gray-500 dark:text-gray-400">Sign in to manage your job listings & applicants</p>
                </div>

                {error && (
                    <div className="p-3 bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-400 rounded-xl text-xs font-semibold border border-red-200 dark:border-red-800">
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="block text-[11px] font-bold uppercase text-gray-500 dark:text-gray-400 mb-1">Email Address</label>
                        <div className="relative">
                            <Mail className="absolute left-3.5 top-3 text-gray-400" size={16} />
                            <input 
                                type="email" 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                placeholder="employer@company.com" 
                                className="w-full pl-10 pr-4 py-2.5 text-xs bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-yellow-400 outline-none dark:text-white"
                                required 
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-[11px] font-bold uppercase text-gray-500 dark:text-gray-400 mb-1">Password</label>
                        <div className="relative">
                            <Lock className="absolute left-3.5 top-3 text-gray-400" size={16} />
                            <input 
                                type="password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                placeholder="••••••••" 
                                className="w-full pl-10 pr-4 py-2.5 text-xs bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-yellow-400 outline-none dark:text-white"
                                required 
                            />
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading}
                        className="w-full bg-[#FED547] hover:bg-yellow-400 text-black font-bold py-3 rounded-xl text-xs transition-all shadow-md flex items-center justify-center gap-2 cursor-pointer"
                    >
                        <span>{loading ? 'Signing in...' : 'Sign In to Employer Dashboard'}</span>
                        <ArrowRight size={16} />
                    </button>
                </form>

                <div className="text-center pt-2 border-t border-gray-100 dark:border-gray-700">
                    <a href="/" className="text-xs text-gray-500 hover:text-gray-900 dark:hover:text-white transition-colors">
                        ← Back to Home
                    </a>
                </div>
            </div>
        </div>
    );
}